import { parse } from 'querystring';
// @ts-ignore
import { formatMessage } from 'umi';
import defaultAvatar from '../assets/default_avatar.jpg';

// @ts-ignore
import defaultSettings from '@@/../../config/defaultSettings';
import { LayoutSettings } from '..';

/**
 * 获取用户头像url
 * @param empNo
 */
export function getUserAvatarUrl(empNo: string): string {
  if (!empNo) {
    return defaultAvatar;
  }
  return `https://w3.envision-group.com/static/p/avatar/${empNo}.jpg`;
}

export function getDefaultSettings(): LayoutSettings {
  return defaultSettings;
}


/**
 * 获取项目标题
 */
export function getGlobalTitle(): string {
  if (defaultSettings.titleId) {
    return formatMessage({ id: defaultSettings.titleId, defaultMessage: defaultSettings.title });
  }
  return defaultSettings.title;
}
